module.exports = __webpack_public_path__ + "img/background_yellow.4c3d90d3.png";